
import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';

/**
 * Fetches the products belonging to a PRODUCT-scoped cart promotion group.
 * @param {number|null} promotionId
 */
export const usePromotionProducts = (promotionId) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!promotionId) {
            setProducts([]);
            return;
        }

        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await ApiClient.performRequest(
                    `cart-promotions/${promotionId}/products`, {}
                );
                setProducts(Array.isArray(response) ? response : []);
            } catch (err) {
                console.error('[OfertasCombinables] Error fetching products for promo', promotionId, err);
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [promotionId]);

    return { products, loading };
};
